import React from "react";
import Styled, { CustomModal, LineBreak } from "./styles";
import { sumBy } from "lodash";

const avg = (items, key) => (sumBy(items, key) / items.length).toFixed(2);

const ModalExhibit7 = ({ comparableCompanies, goBack }) => (
  <CustomModal goBack={goBack}>
    <b>EXHIBIT 7 - Valuation Methods & Comps</b>
    <LineBreak />
    <Styled.ModalTable>
      <tbody>
        <tr>
          <th>Year</th>
          <th>Valuation Method</th>
          <th>Rationale</th>
        </tr>
        <tr>
          <td>1 and 2</td>
          <td>Price to Sales (P/S)</td>
          <td>
            We will value your business using the revenues of a comparable
            public company.
          </td>
        </tr>
        <tr>
          <td>3 and 4</td>
          <td>Price to Earnings (P/E)</td>
          <td>
            We will value your business using the earnings of a comparable
            public company.
          </td>
        </tr>
        <tr>
          <td>5 to 8</td>
          <td>Discounted Cash Flows (DCF)</td>
          <td>
            We will value your business using the free cash flows of a
            comparable public company.
          </td>
        </tr>
      </tbody>
    </Styled.ModalTable>
    <LineBreak />
    <Styled.ModalTable>
      <tbody>
        <tr>
          <th>Comparable</th>
          <th>Price to Sales (P/S)</th>
          <th>Price to Earnings (P/E)</th>
        </tr>
        {comparableCompanies.map(comparableCompany => (
          <tr key={comparableCompany.id}>
            <td>{comparableCompany.name}</td>
            <td>{comparableCompany.price_to_sales.toFixed(2)}</td>
            <td>{comparableCompany.price_to_earnings.toFixed(2)}</td>
          </tr>
        ))}
        <tr className="avg">
          <td>Average Comps</td>
          <td>{avg(comparableCompanies, "price_to_sales")}</td>
          <td>{avg(comparableCompanies, "price_to_earnings")}</td>
        </tr>
      </tbody>
    </Styled.ModalTable>
  </CustomModal>
);

export default ModalExhibit7;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit7.js